import { Typography } from "@mui/material";

interface TitleProps {
  titleText: string;
}

const Title: React.FC<TitleProps> = ({ titleText }) => {
  return (
    <Typography
      marginLeft="40px"
      variant="h1"
      fontFamily="Lato"
      fontSize="32px"
      fontStyle="normal"
      fontWeight={500}
      lineHeight="normal"
    >
      {titleText}
    </Typography>
  );
};

export default Title;
